export const V1_RECEIVE_SSR_LIST = 'V1_RECEIVE_SSR_LIST'

export default data => {
  return {
    type: V1_RECEIVE_SSR_LIST,
    data,
  }
}
